/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var TemplateExpressionTokenType;
(function (TemplateExpressionTokenType) {
    TemplateExpressionTokenType[TemplateExpressionTokenType["Literal"] = 0] = "Literal";
    TemplateExpressionTokenType[TemplateExpressionTokenType["Identifier"] = 1] = "Identifier";
    TemplateExpressionTokenType[TemplateExpressionTokenType["Dot"] = 2] = "Dot";
    TemplateExpressionTokenType[TemplateExpressionTokenType["Comma"] = 3] = "Comma";
    TemplateExpressionTokenType[TemplateExpressionTokenType["Integer"] = 4] = "Integer";
    TemplateExpressionTokenType[TemplateExpressionTokenType["Float"] = 5] = "Float";
    TemplateExpressionTokenType[TemplateExpressionTokenType["LeftParenthesis"] = 6] = "LeftParenthesis";
    TemplateExpressionTokenType[TemplateExpressionTokenType["RightParenthesis"] = 7] = "RightParenthesis";
    TemplateExpressionTokenType[TemplateExpressionTokenType["LeftSquareBracket"] = 8] = "LeftSquareBracket";
    TemplateExpressionTokenType[TemplateExpressionTokenType["RightSquareBracket"] = 9] = "RightSquareBracket";
    TemplateExpressionTokenType[TemplateExpressionTokenType["QuestionMark"] = 10] = "QuestionMark";
    TemplateExpressionTokenType[TemplateExpressionTokenType["EndOfData"] = 11] = "EndOfData";
})(TemplateExpressionTokenType || (TemplateExpressionTokenType = {}));
